import React from 'react'
import '../style/footer.css'

const Footer = () => {
  return (
    <>
    <footer className="footer">
      <div className="f-container">
      <h2>ASIA21</h2>
      <h4>Developed and Managed By <span>Aaman Pansare</span>.
        <br></br>

© ASIA21 2024. All rights reserved. </h4>
      </div>
    </footer>
   
    </>
  )
}

export default Footer
